import { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@mui/material';
import { useSnackbar } from 'notistack';

import { IToastCloseButtonProps } from './ToastCloseButton.interface';

export const ToastCloseButton: FC<IToastCloseButtonProps> = ({ className, toastKey }) => {
  const { t } = useTranslation();
  const { closeSnackbar } = useSnackbar();

  const closeSnackbarAction = useCallback(() => closeSnackbar(toastKey), [closeSnackbar, toastKey]);

  return (
    <Button className={className} color="inherit" onClick={closeSnackbarAction}>
      {t('common.close')}
    </Button>
  );
};

export default ToastCloseButton;
